export default __webpack_public_path__ + "static/media/icon_setting.844a5a24.svg";